module.exports = "<div><img src=\"../../../assets/loading.png\"></div>"